var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgressTracker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0008 2.78947C18.0008 3.77777 17.1997 4.57895 16.2113 4.57895C15.223 4.57895 14.4219 3.77777 14.4219 2.78947C14.4219 1.80117 15.223 1 16.2113 1C17.1997 1 18.0008 1.80117 18.0008 2.78947Z",
    stroke: "url(#paint0_linear_6573_1855)",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0794 7.17864C17.1053 7.96988 17.1053 8.88413 17.1053 9.94716C17.1053 13.7432 17.1053 15.6413 15.926 16.8205C14.7467 17.9998 12.8486 17.9998 9.05263 17.9998C5.25659 17.9998 3.35856 17.9998 2.17928 16.8205C1 15.6413 1 13.7432 1 9.94716C1 6.15112 1 4.25309 2.17928 3.07381C3.35856 1.89453 5.25659 1.89453 9.05263 1.89453C10.1157 1.89453 11.0299 1.89453 11.8211 1.92043",
    stroke: "url(#paint1_linear_6573_1855)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57812 11.7367L7.07703 9.23775C7.42645 8.88836 7.99298 8.88836 8.34237 9.23775L9.76125 10.6566C10.1106 11.006 10.6772 11.006 11.0266 10.6566L13.5255 8.15771",
    stroke: "url(#paint2_linear_6573_1855)",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6573_1855",
    x1: 15.3099,
    y1: 1.21481,
    x2: 17.078,
    y2: 4.27718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6573_1855",
    x1: 4.99624,
    y1: 2.86116,
    x2: 12.9525,
    y2: 16.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6573_1855",
    x1: 6.79826,
    y1: 8.37252,
    x2: 7.69348,
    y2: 12.2489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressTracker);
export default __webpack_public_path__ + "static/media/progressTracker.fcff63a43c57f3a20a0014a27456cfe2.svg";
export { ForwardRef as ReactComponent };